function isLoading(statuses: string[]) {
  return statuses.filter((status) => status === "loading").length > 0;
}

export default isLoading;
